import { render } from "./form.vue?vue&type=template&id=5fcc8476"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=5fcc8476&lang=scss"
script.render = render

export default script